// Labels and colours mirror the work-placement StageBadge so a placement's status
// reads consistently wherever it is surfaced. Keyed by StudentPlacementStatus values
// (Prisma client enums are string-literal unions, so no svc-api-db dependency is needed).
export const placementStatusMetadata = {
  AWAITING_CHECKLIST: { label: 'Awaiting docs', color: 'orange', variant: 'outline' },
  AWAITING_APPROVAL: { label: 'Pending approval', color: 'yellow', variant: 'outline' },
  AWAITING_PLACEMENT: { label: 'Sourcing', color: 'blue', variant: 'outline' },
  APPLYING: { label: 'Applying', color: 'cyan', variant: 'outline' },
  INTERVIEWING: { label: 'Interviewing', color: 'purple', variant: 'outline' },
  IN_PROGRESS: { label: 'In progress', color: 'teal', variant: 'outline' },
  AWAITING_EVIDENCE: { label: 'Awaiting evidence', color: 'pink', variant: 'outline' },
  COMPLETED: { label: 'Completed', color: 'gray', variant: 'outline' },
  FAILED: { label: 'Failed', color: 'red', variant: 'outline' },
  CANCELLED: { label: 'Cancelled', color: 'gray', variant: 'outline' },
} as const;
